import { forwardRef, type Ref, type SVGProps } from "react";
const IconKeyOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M23.83 2a1 1 0 0 0-.688.274l-.19.18a1 1 0 0 0-.312.726v2.35h-2.4a1 1 0 0 0-1 1v2.36h-2.37a1 1 0 0 0-.707.293l-1.184 1.184a10 10 0 1 0 6.608 6.31l7.951-7.97A1 1 0 0 0 29.83 8V3a1 1 0 0 0-1-1zm.81 4.53V4h3.19v3.586l-8.118 8.138a1 1 0 0 0-.212 1.098 8 8 0 1 1-4.596-4.374 1 1 0 0 0 1.053-.23l1.327-1.328h2.956a1 1 0 0 0 1-1V7.53h2.4a1 1 0 0 0 1-1M9.358 20.37a1.67 1.67 0 0 1 .962-.27v.05c.442.005.865.18 1.18.49a1.67 1.67 0 0 1-1.82 2.725A1.6 1.6 0 0 1 9.14 23a1.67 1.67 0 0 1 .218-2.63" />
  </svg>
);
const ForwardRef = forwardRef(IconKeyOutlineSVG);
ForwardRef.displayName = "IconKeyOutline";
export { ForwardRef as IconKeyOutline };
